// ----------------------------------------------------------------------
// <copyright file="Izenda.ConnectionDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';

export default {
  MIDDLE_MIN_WIDTH: 0,
  MIDDLE_MAX_WIDTH: 250,
  MESSAGE: {
    get CANCEL() {
      return localizer.getText('TENANT_CONSTANT_MESSAGE_CANCEL');
    },
    get SAVE() {
      return localizer.getText('TENANT_CONSTANT_MESSAGE_SAVE');
    },
    get DELETE() {
      return localizer.getText('TENANT_CONSTANT_MESSAGE_DELETE');
    },
    get DEACTIVATE() {
      return localizer.getText('TENANT_CONSTANT_MESSAGE_DEACTIVATE');
    }
  },

  TENANT_ID_CONSTRAINT: {
    presence: {
      presence: true,
      get message() {
        return localizer.getText('TENANT_CONSTANT_MESSAGE_TENANT_ID_CONSTRAINT');
      }
    }
  },

  TENANT_NAME_CONSTRAINT: {
    presence: {
      presence: true,
      get message() {
        return localizer.getText('TENANT_CONSTANT_MESSAGE_TENANT_NAME_CONSTRAINT');
      }
    }
  },

  TENANT_STATE: {
    get ACTIVATE() {
      return localizer.getText('COMMON_LABEL_ACTIVATE');
    },
    get DEACTIVATE() {
      return localizer.getText('COMMON_LABEL_DEACTIVATE');
    }
  },

  TENANT_PERMISSIONS: {
    ACCESS: {
      ACCESS_LIMIT: {
        get AVAILABLE_TREE_HEADER() {
          return localizer.getText('TENANT_CONSTANT_TENANT_PERMISSIONS_AVAILABLE_TREE_HEADER');
        },
        get SHARE_WITH_TREE_HEADER() {
          return localizer.getText('TENANT_CONSTANT_TENANT_PERMISSIONS_SHARE_WITH_TREE_HEADER');
        }
      }
    },
    REPORT: {
      CATEGORY_ACCESSIBILITY: {
        get AVAILABLE_TREE_HEADER() {
          return localizer.getText('TENANT_CONSTANT_REPORT_AVAILABLE_TREE_HEADER');
        },
        get VISIBLE_TREE_HEADER() {
          return localizer.getText('TENANT_CONSTANT_REPORT_VISIBLE_TREE_HEADER');
        },
        get SAVABLE_TREE_HEADER() {
          return localizer.getText('TENANT_CONSTANT_REPORT_SAVABLE_TREE_HEADER');
        }
      }
    },
    DASHBOARD: {
      CATEGORY_ACCESSIBILITY: {
        get AVAILABLE_TREE_HEADER() {
          return localizer.getText('TENANT_CONSTANT_DASHBOARD_AVAILABLE_TREE_HEADER');
        },
        get VISIBLE_TREE_HEADER() {
          return localizer.getText('TENANT_CONSTANT_DASHBOARD_VISIBLE_TREE_HEADER');
        },
        get SAVABLE_TREE_HEADER() {
          return localizer.getText('TENANT_CONSTANT_DASHBOARD_SAVABLE_TREE_HEADER');
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.TenantConstants.js